module.exports = {"F":"Female","M":"Male","N":"Non-binary","P":"Prefer Not To Answer","O":"Self-Identify"}